import { Grid, styled } from "@mui/material";
import { IStyledChatMessageProps } from "./types";

const StyledMessage = styled(Grid, {
    shouldForwardProp: (prop) => prop !== "answer" && prop !== "context",
})<IStyledChatMessageProps>(({ theme, answer, context }) => {
    const bubbleColor = answer ? "#111213" : "#4988AE";

    return ({
        justifyContent: `${answer ? 'flex-start' : 'flex-end'}`,
        "&>.MuiGrid-root>.MuiCard-root": {
            padding: theme.spacing(1),
            borderRadius: `${(theme as any).shape.border.general.radius[8]} ${context && (theme as any).shape.border.general.radius[0]}`,
            backgroundColor: `${context && !answer ? (theme as any).palette.neutral.lighter : (theme as any).palette.neutral.darker}`,
            color: `${answer ? (theme as any).palette.neutral.lighter : (theme as any).palette.neutral.darker}`,
            overflowX: "auto",
            "&>.MuiGrid-root:nth-of-type(1)":{
                gap: theme.spacing(2),
                alignItems: "center",
                "&>.MuiGrid-root>.MuiTypography-root" : {
                    color: `${answer ? (theme as any).palette.primary.lighter : (theme as any).palette.primary.darker} !important`
                }
            },
            "&>.MuiGrid-root:last-child":{
                marginTop: theme.spacing(1),
                padding: theme.spacing(1),
                backgroundColor: bubbleColor
            },
            "& table": {
                display: "block",
                width: "max-content",
                borderCollapse: "collapse",
                color: "inherit",
                margin: `${theme.spacing(1)} 0`,
                whiteSpace: "nowrap",
            },
            "& th, & td": {
                border: "1px solid #ffffff",
                padding: theme.spacing(0.5),
            }
        },
        "&>.MuiGrid-root>.MuiGrid-root": {
            padding: theme.spacing(1),
            "&>.MuiIconButton-root": {
                width: theme.spacing(3),
                height: theme.spacing(3),
                "&>.MuiSvgIcon-root":{
                    fontSize: theme.spacing(2)
                }
            }
        }
    })
})

export { StyledMessage };
